import './base/';

/*
 * Polyfills
 */

import './polyfills/object-fit';

/*
 * Utils
 */
import bodyLoaded from './utils/bodyLoaded';
import isMobile from './utils/isMobile';
import isMobileDevice from './utils/isMobileDevice';

/*
 * Modules
 */
import './modules/navClick';
import './modules/navClose';
import './modules/navTrigger';
import './modules/initSliders';
import './modules/appendWeglotToHeader';
import './modules/galleryPopup';
import './modules/fixCalendarLayout';
import './modules/initSelectric';
import './modules/initModalSearch';
import './modules/product';
